<template>

  <div class="iframe-frame">

    <div class="desktop-iframe video">
      <iframe :src='desksrc' frameborder="0" allowfullscreen loading="lazy"></iframe>
    </div>

    <div class="mobile-iframe video">
      <iframe :src="mobsrc" frameborder="0" allowfullscreen loading="lazy"></iframe>
      <div class="mobile-iframe-img" @click="loadMobile" v-if="!mobsrc"></div>
    </div>

  </div>

</template>


<script>

export default {

  data(){
    return {
      desksrc: '',
      mobsrc: '',
    }
  },

  props: {
    url: { type: String, default: '' },
    autoplay: { type: Boolean, default: false }
  },

  mounted(){
    window.addEventListener('resize', this.loadIframe);
    this.loadIframe();
    this.loadMobile();
  },

  computed: {
    type: function(){
      let url = this.url;
      if(url.includes('youtu')){
        return 'youtube';
      } else if(url.includes('vimeo')){
        return 'vimeo';
      }
    },
    videoid: function(){
      let url = this.url;
      if(url.includes('youtube')){
        return url.substring(url.lastIndexOf('?v=')+3);
      } else if(url.includes('youtu.be')){
        return url.substring(url.lastIndexOf('/')+1);
      } else if(url.includes('vimeo')){
        return url.substring(url.lastIndexOf('com/')+4);
      }
    },
    isAutoplay: function(){
      if (this.autoplay){
        return '&autoplay=1';
      }
    },
    embedable: function(){
      if(this.type == 'youtube'){
        return 'https://www.youtube.com/embed/' + this.videoid + '?rel=0&modestbranding=1&controls=0' + this.isAutoplay;
      } else if (this.type == 'vimeo'){
        return 'https://player.vimeo.com/video/' + this.videoid;
      }
    }
  },

  methods: {
    loadIframe(){
      console.log('load iframe')
      if (window.matchMedia("(min-width: 1050px)").matches) {
        this.desksrc = this.embedable;
      } else {
        this.desksrc = '';
      }
    },
    loadMobile(){
      this.mobsrc = this.embedable;
    }
  },

  watch: {
    url: function(){
      this.loadIframe();
    }
  }
}

</script>